import {
  TASK_ACTION_HISTORY_ACTION_TYPE_MAP,
  TASK_ACTION_HISTORY_DOMAIN_MAP,
} from '@/lib/queries/business/v1/task/action/history/constants'
import { type ValueOf } from '@/lib/utils/type'

import actionCompletedIcon from '../../icons/recent-activity-action-completed-icon.svg'
import taskFinishIcon from '../../icons/recent-activity-task-finish-icon.svg'
import taskRevertIcon from '../../icons/recent-activity-task-revert-icon.svg'

export const getDescriptionData = ({
  actionType,
  actionTitle = '',
  domain,
}: {
  actionType: ValueOf<typeof TASK_ACTION_HISTORY_ACTION_TYPE_MAP>
  domain: ValueOf<typeof TASK_ACTION_HISTORY_DOMAIN_MAP>
  actionTitle?: string
}) => {
  if (actionType === TASK_ACTION_HISTORY_ACTION_TYPE_MAP.complete && domain === TASK_ACTION_HISTORY_DOMAIN_MAP.task) {
    return 'Finish Task'
  }

  if (actionType == TASK_ACTION_HISTORY_ACTION_TYPE_MAP.complete && domain === TASK_ACTION_HISTORY_DOMAIN_MAP.action) {
    return `Completed [${actionTitle}]`
  }

  if (actionType === TASK_ACTION_HISTORY_ACTION_TYPE_MAP.revoke && domain === TASK_ACTION_HISTORY_DOMAIN_MAP.task) {
    return 'Back to Action'
  }
}

export const getIconData = (
  actionType: ValueOf<typeof TASK_ACTION_HISTORY_ACTION_TYPE_MAP>,
  domain: ValueOf<typeof TASK_ACTION_HISTORY_DOMAIN_MAP>
) => {
  if (actionType === TASK_ACTION_HISTORY_ACTION_TYPE_MAP.complete && domain === TASK_ACTION_HISTORY_DOMAIN_MAP.task) {
    return {
      icon: taskFinishIcon,
      altText: 'task finished icon',
    }
  }

  if (actionType === TASK_ACTION_HISTORY_ACTION_TYPE_MAP.complete && domain === TASK_ACTION_HISTORY_DOMAIN_MAP.action) {
    return {
      icon: actionCompletedIcon,
      altText: 'action completed icon',
    }
  }

  if (actionType === TASK_ACTION_HISTORY_ACTION_TYPE_MAP.revoke && domain === TASK_ACTION_HISTORY_DOMAIN_MAP.task) {
    return {
      icon: taskRevertIcon,
      altText: 'task reverted icon',
    }
  }
}
